import { __rest } from "tslib";
import { DEFAULT_SUBSTRUCTURE_LAYOUT_PROPS, } from "./SubstructureLayout";
/**
 * Provides defaults values for {@link SubstructureLayoutProps}
 * @param props
 * @returns
 */
export function getSubstructureLayoutPropsWithFallback(props) {
    const { variant = DEFAULT_SUBSTRUCTURE_LAYOUT_PROPS.variant, defaultExpanded = DEFAULT_SUBSTRUCTURE_LAYOUT_PROPS.defaultExpanded, instanceButtonOrder = DEFAULT_SUBSTRUCTURE_LAYOUT_PROPS.instanceButtonOrder, elementOrder = DEFAULT_SUBSTRUCTURE_LAYOUT_PROPS.elementOrder, custom = DEFAULT_SUBSTRUCTURE_LAYOUT_PROPS.custom } = props, restProps = __rest(props, ["variant", "defaultExpanded", "instanceButtonOrder", "elementOrder", "custom"]);
    return Object.assign({ variant,
        defaultExpanded,
        instanceButtonOrder,
        elementOrder,
        custom }, restProps);
}
//# sourceMappingURL=getSubstructureLayoutPropsWithFallback.js.map